<template>
    <div>
        <div class="custom-search d-flex justify-content-between mb-2">
            <div>
                <b-button
                        id="importExcelButton"
                        variant="success"
                        class="mr-1"
                        @click="downloadSample"
                >
                    Mintafájl letöltése
                </b-button>
            </div>
        </div>
        <b-card-code
                title="Importálás"
        >
            <ImportSkeleton
                    :key="importKey"
                    :model-type="'App\\Models\\RecordCatch'"
                    :columns="columns"
                    :column-titles="columnTitles"
                    :column-definitions="columnDefinitions"
                    :parent-loading="loading"
                    :parent-is-file-valid="isFileValid"
                    :preview-data="previewData"
                    :be-error-messages="beErrorMessages"
                    :preview-error-messages="previewErrorMessages"
                    :with-zip="true"
                    @file-selected="loadPreview"
                    @reset="resetForm"
                    @saved="save"
            />
        </b-card-code>
    </div>
</template>

<script>
import {
    BButton,
    VBTooltip,
} from 'bootstrap-vue'
import FileSaver from 'file-saver'
import ImportSkeleton from '@/views/pages/_components/_import/ImportSkeleton.vue'
import BCardCode from "@core/components/b-card-code";

export default {
    components: {
        BCardCode,
        BButton,
        ImportSkeleton,
        VBTooltip,
    },
    directives: {
        'b-tooltip': VBTooltip,
    },
    data() {
        return {
            role: 'record_catch',
            columns: [
                'fisherman_name',
                'fishing_card_number',
                'catch_time',
                'water_code',
                'fishing_place',
                'fish_type_name',
                'weight',
                'length',
                'perimeter',
                'bait_name',
                'released',
                'competition',
                'report',
                'foreign_key',
                'image_1_filename',
                'image_1_pr',
                'image_2_filename',
                'image_2_pr',
                'image_2_filename',
                'image_3_pr'
            ],
            columnTitles: [
                'Horgász neve',
                'Horgászkártya száma',
                'Fogás időpontja',
                'Fogás helye (víztérkód)',
                'Fogás helye (hely)',
                'Halfaj',
                'Tömeg (kg)',
                'Hossz (cm)',
                'Kerület (cm)',
                'Csali',
                'C&R',
                'Verseny',
                'Beszámoló',
                'Idegen kulcs',
                'Fotó 1 fájl',
                'Fotó 1 pr',
                'Fotó 2 fájl',
                'Fotó 2 pr',
                'Fotó 3 fájl',
                'Fotó 3 pr',
            ],
            columnDefinitions: {},
            beErrorMessages: {
                file: [],
            },
            previewErrorMessages: {},
            previewData: [],
            loading: false,
            isFileValid: false,
            importKey: 0,
        }
    },
    created() {
        this.getValidationRules()
    },
    methods: {
        downloadSample() {
            this.$store.dispatch('downloadRecordCatchImportSample').then(response => {
                let filename = 'rekordok-import-minta.xlsx'
                FileSaver.saveAs(response.data, filename)
            })
        },
        getValidationRules() {
            this.loading = true
            this.$store.dispatch('getRecordCatchImportValidationRules').then(response => {
                this.columnDefinitions = response.data.rules
            }).catch(error => {
                this.$helpers.showErrorToast(error.toString())
            }).finally(() => {
                this.loading = false
            })
        },
        resetForm() {
            this.previewErrorMessages = {}
            this.previewData = []
            this.isFileValid = false
            this.beErrorMessages = {
                file: []
            }
        },
        loadPreview(file) {
            this.loading = true
            this.isFileValid = false
            this.previewErrorMessages = {}
            this.beErrorMessages = {}

            let fd = new FormData()
            fd.append('file', file)

            this.$store.dispatch('loadRecordCatchImportPreview', fd).then(response => {
                this.previewData = response.data.data
                this.isFileValid = true
            }).catch(error => {
                let showErrorToast = true
                let toastErrorMessage
                if (error.response && error.response.status === 422) {
                    const responseData = error.response.data

                    if (responseData.extraData && responseData.extraData.previewError) {
                        this.previewErrorMessages = responseData.errors
                    } else {
                        this.beErrorMessages = responseData.errors
                        showErrorToast = false
                    }

                    if(responseData.message) {
                        toastErrorMessage = responseData.message
                        showErrorToast = true
                    }
                }
                if(error.response.status && error.response.status === 413){
                    toastErrorMessage = 'A feltölteni kívánt fájl túl nagy. Maximum feltölthető fájlméret: 64MB'
                    showErrorToast = true
                }

                this.isFileValid = false
                this.previewData = {}

                if (showErrorToast) this.$helpers.showErrorToast(toastErrorMessage)
            }).finally(() => {
                this.loading = false
            })
        },
        save(file) {
            this.loading = true

            let fd = new FormData()
            fd.append('file', file)

            this.$store.dispatch('fishermanImport', fd).then(() => {
                this.$helpers.showSuccessToast('Az importálás elkezdődött és a háttérben folytatódik. E-mailben fogjuk értesíteni az eredményről.')

                this.previewData = {}
                this.previewErrorMessages = {}
                this.beErrorMessages = {
                    file: [],
                }
                this.isFileValid = false
                this.importKey++
            }).catch(error => {
                let showErrorToast = true
                let toastErrorMessage = error.response.message
                if (error && error.response && error.response.status && error.response.status === 422) {
                    this.beErrorMessages = error.response.data.errors
                    showErrorToast = false
                }
                if(error.response.status && error.response.status === 413){
                    toastErrorMessage = 'A feltölteni kívánt fájl túl nagy. Maximum feltölthető fájlméret: 64MB'
                    showErrorToast = true
                }

                if (showErrorToast) this.$helpers.showErrorToast(toastErrorMessage)
            }).finally(() => {
                this.loading = false
            })
        }
    },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-good-table.scss';
</style>
